import { FC, useMemo } from "react"
import styles from "@/pages/Shop/Shop.module.scss"
import { GoldCardItem } from "@/pages/Shop/ui/GoldCardItem"
import { ShopCurrencies } from "@/pages/Shop/values"
import { CARD_TYPE } from "@/store/apis/deckAPI"
import { STORE_ITEM_TYPES, useGetStoreQuery } from "@/store/apis/storeAPI"
import { DEFAULT_PAGE_SIZE } from "@/ui/Pagination"
import { ShopCurrencySwitch } from "../ShopCurrencySwitch"

const GOLD_CARDS_ORDER: readonly CARD_TYPE[] = [
  CARD_TYPE.CLEANSING,
  CARD_TYPE.RUNE_MASTER,
  CARD_TYPE.LITTLE_MISCHIEF
]

export const GoldCardsTab: FC = () => {
  const { data: store } = useGetStoreQuery({
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    type: STORE_ITEM_TYPES.CARD,
    populate: true
  })

  const sortedItems = useMemo(() => {
    const items = store?.items ?? []
    const byType = new Map(items.map((item) => [item.data?.type, item]))
    const known = new Set<string>(GOLD_CARDS_ORDER)

    const ordered = GOLD_CARDS_ORDER.flatMap((type) => {
      const item = byType.get(type)
      return item ? [item] : []
    })
    const rest = items.filter((item) => !known.has(item.data?.type ?? ""))

    return [...ordered, ...rest]
  }, [store?.items])

  return (
    <>
      <ShopCurrencySwitch currencies={ShopCurrencies} />
      <div className={styles.Shop_content_body_list}>
        {sortedItems.map((item) => (
          <GoldCardItem {...item} key={item._id} />
        ))}
      </div>
    </>
  )
}
